import { render, staticRenderFns } from "./IconDot.vue?vue&type=template&id=99daeec2&scoped=true"
import script from "./IconDot.vue?vue&type=script&lang=js"
export * from "./IconDot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99daeec2",
  null
  
)

export default component.exports